/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ContractInfoResponseData = {
  type: 'all-of',
  contains: [{
    type: 'Contract',
  }, {
    properties: {
      reviewers: {
        type: 'array',
        contains: {
          type: 'ContractReviewerBasicInfo',
        },
      },
      reviewerAssignments: {
        type: 'array',
        contains: {
          type: 'AssignContractReviewer',
        },
      },
      signers: {
        type: 'array',
        contains: {
          type: 'Signer',
        },
      },
    },
  }],
} as const;
